import React, { useEffect } from 'react';
import {
  View,
  Text,
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CUSTOM_PRELOADER_IMG, CUSTOM_PRELOADER_LOADER, CUSTOM_PRELOADER_VIDEO } from '../../assets';
import { setGoHome, setIsShownWelcomeScreen, setRedirectToTabId, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { VideoHandler } from '../../components/videoComp/video';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHECK_IN, HOME_PAGE } from '../../navigation/StackNavigator/routes';
import { useNavigation } from '@react-navigation/native';
import { CustomModal } from '../../components/customModal';
import LottieView from 'lottie-react-native';
import FadeTransition from '../../components/fadeTransition';
import RenderHTML from 'react-native-render-html';
import { ISINROOMTAB } from '../../config/Constant';

const WelcomeScreen_Landscape = () => {

  const dispatch = useDispatch();
  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const navigation = useNavigation();
  const {width} = useWindowDimensions();

  const { webAppWidgetsInfo, currentLayout } = useSelector(
    (state) => state.deviceConfigSlice
  );


  const { allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

  const hotelLogoImageUrl = webAppWidgetsInfo?.screenInfoAfterLoader?.hotelLogo ? getCleanUrl(webAppWidgetsInfo?.screenInfoAfterLoader?.hotelLogo)  : getCleanUrl(currentLayout?.brandingInfo?.hotelLogoImageUrl);

  const screenInfo = webAppWidgetsInfo?.screenInfoAfterLoader || {};
  const { backgroundVideo = {}, imageURI, btnAction, logoURI } = screenInfo;
  const { videoURI, posterURI, enableSound } = backgroundVideo;

  const welcomeImg = imageURI ? { uri: getCleanUrl(imageURI) } : CUSTOM_PRELOADER_IMG;
  const welcomeVideo = videoURI ? getCleanUrl(videoURI) : CUSTOM_PRELOADER_VIDEO;
  const welcomePoster = posterURI ? getCleanUrl(posterURI) : CUSTOM_PRELOADER_IMG;


  useEffect(() => {
    // Preload the Home screen in the background
    navigation.preload(HOME_PAGE);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleWelcome = () => {
    dispatch(setIsShownWelcomeScreen(true));
    dispatch(setGoHome(true));
  };


  const handlePrimaryBtnClick = () => {
    const widgetWithPath = btnAction?.params?.appPath?.trim();

    if (widgetWithPath) {

      if (widgetWithPath.toLowerCase() == "findres" || (widgetWithPath == CHECK_IN && allowUserLoginViaFindingReservation)) {
        handleLoginToRoom();
        return;
      }

      handleWelcome();
      setTimeout(() => {
        navigation.navigate(widgetWithPath);
      }, 0);

    }
  }
  const handleLoginToRoom = () => {
    // handleWelcome();
    // dispatch(setRedirectToTabId("mystay"));

    setTimeout(() => {
      dispatch(setShowLoginModal(true));
    }, 200);
  }

  const renderTopLogoSection = () => (
    <View style={getStyles(['welcomeScrTopLogoContainer_landscape'])} id='welcomeScrTopLogoContainer_landscape'>
      <ImageComp
        source={getCleanUrl(logoURI)}
        style={getStyles(['welcomeScreenTopLogoStyle_landscape'])}
        resizeMode="contain"
        id='welcomeScreenTopLogoStyle_landscape'
      />
    </View>
  )

  const renderLogoSection = () => (
    <View style={getStyles(['welcomeScrLogoContainer_landscape'])} id='welcomeScrLogoContainer_landscape'>

      {CUSTOM_PRELOADER_LOADER ?
        <LottieView
          source={CUSTOM_PRELOADER_LOADER}
          style={getStyles(['welcomeScreenLogoLottie_landscape'])}
          autoPlay={false}
          progress={1}
          id='welcomeScreenLogoLottie_landscape'
        />
        :
        <>
          <ImageComp
            source={hotelLogoImageUrl}
            style={getStyles(['welcomeScreenLogoStyle_landscape'])}
            resizeMode="contain"
            id='welcomeScreenLogoStyle_landscape'
          />
          <Text style={getStyles(['welcomeScreenLogoText_landscape'])} id='welcomeScreenLogoText_landscape' >
            {t('welcome_screen.hotel_name')}
          </Text>
        </>
      }
    </View>
  );
  
  const customWidgetTitleStyle = getStyles(['primaryBtnTxt', 'welcomeScreenPrimaryBtnTxt_landscape']);
  const customWidgetSubTitleStyle = getStyles(['tertiaryBtnTxt', 'welcomeScreenTertiaryBtnTxt_landscape']);

  const customWidgetHeaderTxtStyle = getStyles(['welcomeScreenHeaderTxt_landscape']);

  const screenContent = () => (


    <View style={getStyles(['customModalContainer_landscape', 'welcomeScreenModalContainer_landscape'])} id='customModalContainer_landscape welcomeScreenModalContainer_landscape'>
      <FadeTransition duration={300}>
        {/* <View style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)" }}></View> */}

        <View style={getStyles(['customModalInnerContainer_landscape', 'welcomeScreenModalInnerContainer_landscape'])} id='customModalInnerContainer_landscape welcomeScreenModalInnerContainer_landscape'>

          <View style={getStyles(['welcomeScreenContent_landscape'])} id='welcomeScreenContent_landscape' >

            <View style={getStyles(['welcomeScreenHeaderTxtCont_landscape'])} id='welcomeScreenHeaderTxtCont_landscape' >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetHeaderTxtStyle}
                source={{html: t('welcome_screen.welcome_screen_header_msg')}}
                systemFonts={[customWidgetHeaderTxtStyle.fontFamily]}
              />
            </View>

            <CustomPressable style={getStyles(['primaryBtn','welcomeScreenPrimaryBtn_landscape'])} id='primaryBtn welcomeScreenPrimaryBtn_landscape' onPress={handlePrimaryBtnClick} >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetTitleStyle}
                source={{html: t('welcome_screen.primary_button')}}
                systemFonts={[customWidgetTitleStyle.fontFamily]}
              />
            </CustomPressable>

            <CustomPressable style={getStyles(['tertiaryBtn', 'welcomeScreenTertiaryBtn_landscape'])} onPress={handleWelcome} id='tertiaryBtn welcomeScreenTertiaryBtn_landscape' >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetSubTitleStyle}
                source={{html: t('welcome_screen.secondary_button')}}
                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
              />
            </CustomPressable>

            {!ISINROOMTAB && <View style={getStyles(['welcomeScreenBottomLoginContainer_landscape'])} id='welcomeScreenBottomLoginContainer_landscape' >
              <Text style={getStyles(['welcomeScreenBottomLoginTxt_landscape'])} id='welcomeScreenBottomLoginTxt_landscape' >
                {t('welcome_screen.welcome_screen_login')}
              </Text>
              <CustomPressable onPress={handleLoginToRoom} style={getStyles(['welcomeScreenBottomLoginBtn_landscape'])} id='welcomeScreenBottomLoginBtn_landscape' >
                <Text style={getStyles(['welcomeScreenBottomLoginBtnTxt_landscape'])} id='welcomeScreenBottomLoginBtnTxt_landscape' >
                  {t('welcome_screen.welcome_screen_login_button')}
                </Text>
              </CustomPressable>
            </View>}

            <View style={getStyles(['welcomeScreenBottomTxtCont_landscape'])} id='welcomeScreenBottomTxtCont_landscape' >
              <Text style={getStyles(['welcomeScreenBottomTxt_landscape'])} id='welcomeScreenBottomTxt_landscape' >
                {t('welcome_screen.welcome_screen_msg')}
              </Text>
            </View>
          </View>
        </View>
      </FadeTransition>
    </View>
  )

  return welcomeVideo ? (
    <View style={getStyles(['welcomeScreenContainer_landscape'])} id='welcomeScreenContainer_landscape' >
      <View style={getStyles(['welcomeScreenOverlay_landscape', {...StyleSheet.absoluteFillObject}])} />
      <VideoHandler
        posterSrc={welcomePoster}
        videoSrc={welcomeVideo}
        enableSound={enableSound}
        style={getStyles(['welcomeScreenVideo_landscape'])}
        id='welcomeScreenVideo_landscape'
      />
      {renderTopLogoSection()}
      {renderLogoSection()}
      {screenContent()}

    </View>
  ) : (
    <ImageBackground
      source={welcomeImg}
      style={getStyles(['welcomeScreenContainer_landscape', ])}
      resizeMode="cover"
      id='welcomeScreenContainer welcomeScreenContainerImage_landscape'
      imageStyle={getStyles(["welcomeScreenContainerImage_landscape"])}
    >
      <View style={getStyles(['welcomeScreenOverlay_landscape', {...StyleSheet.absoluteFillObject}])} />
      {renderTopLogoSection()}
      {renderLogoSection()}
      {screenContent()}
    </ImageBackground>
  )
};

export default React.memo(WelcomeScreen_Landscape);
